class OurTeamModel {
	id;
	name;
	job;
	image;

	constructor({
		_id = '', name = '', job = '', image = '',
	}) {
		this.id = _id;
		this.name = name;
		this.job = job;
		this.image = image;
	}
}

export default OurTeamModel;
